module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"center center\" fxLayoutGap=\"10px\">\r\n    <mat-icon>done</mat-icon>\r\n    <span>Your enquiry has been submitted.</span>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/enquiry-submitted/enquiry-submitted.component.html
// module id = 553
// module chunks = 1